import React from 'react';
import { createUseStyles } from 'react-jss';
import { Theme } from '@app/theme';
import { DurationChip, IncentiveChip } from '@app/core';
import { Participation } from '@app/api';
import classnames from 'classnames';
import { ParticipationStatusChip } from './ParticipationStatusChip';

const useStyles = createUseStyles((theme: Theme) => ({
  mainContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.marginBase * 2,
    [theme.media.mobile]: {
      flexDirection: 'column',
    },
  },
  containerTags: {
    display: 'none',
    [theme.media.mobile]: {
      display: 'flex',
      flexWrap: 'wrap',
      gap: theme.marginBase,
    },
  },
  title: {
    ...theme.fonts.h4,
    [theme.media.mobile]: {
      display: 'inline-block',
      width: '100%',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      maxWidth: '50ch',
    },
  },
}));

interface Props {
  participation: Participation;
}

export const ConfirmedParticipationBottomHeader = ({
  participation,
}: Props) => {
  const classes = useStyles();

  return (
    <div className={classes.mainContainer}>
      <div className={classnames(classes.containerTags)}>
        <ParticipationStatusChip status={participation.status} />
        <IncentiveChip participation={participation} color="inkSecondary" />
        <DurationChip participation={participation} color="inkSecondary" />
      </div>
      <h1 className={classes.title}>{participation.session?.title}</h1>
    </div>
  );
};
